import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCursor1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCursor1"><Path d="M3 3L9.86111 22L13.5556 13.5556L22 9.86111L3 3Z" stroke="currentColor" strokeWidth="1.02703"/></CentralIconBase>;
});

export default IconCursor1;
